export default __webpack_public_path__ + "static/media/lieferheld_logo.c8a0122d.svg";